import { FieldConfig } from 'constants/FumigationCompanyConstants/FumigationCompanyConstants';

const FumigationContractorListConstants = {

    COMPANY_NAME: {
        label: 'Fumigation Company Name',
        name: 'Fumigation Company Name',
        sqlColumn: 'fumigationCompanyNameAdmin',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    PHONE_NUMBER: {
        label: 'Fumigation Phone Number',
        name: 'Fumigation Phone Number',
        sqlColumn: 'fumigationPhoneNumberAdmin',
        isRequired: true,
        subtext: '',
    } as FieldConfig,

    NOTES: {
        label: 'Fumigation Company Notes',
        name: 'Fumigation Company Notes',
        sqlColumn: 'fumigationCompanyNotesAdmin',
        isRequired: false,
        subtext: '',
    } as FieldConfig,

    STATUS: {
        label: 'Status',
        name: 'Status',
        sqlColumn: 'status',
        isRequired: false,
        subtext: '',
    } as FieldConfig,

    LAST_UPDATED: {
        label: 'Last Updated',
        name: 'Last Updated',
        sqlColumn: 'updateDttm',
        isRequired: false,
        subtext: '',
    } as FieldConfig,

};

export default FumigationContractorListConstants;
